import { useEffect, useState } from "react";
import { useQuery } from "react-query";

interface UseVideoPreviewThumbnailsProps {
  previewThumbnailsUrl?: string;
}

export const useVideoPreviewThumbnails = ({
  previewThumbnailsUrl,
}: UseVideoPreviewThumbnailsProps) => {
  const [blobUrl, setBlobUrl] = useState<string | undefined>();

  const { data: vttContent, isLoading } = useQuery({
    queryKey: ["mediaPlayer", "videoPreviewThumbnails", previewThumbnailsUrl],
    queryFn: async () => {
      if (!previewThumbnailsUrl) return;

      const response = await fetch(previewThumbnailsUrl);

      if (!response.ok) {
        throw new Error(
          `Failed to fetch video preview thumbnails VTT: ${response.status} ${response.statusText}`,
        );
      }

      return response.text();
    },
    enabled: !!previewThumbnailsUrl,
    staleTime: Infinity,
    cacheTime: Infinity,
  });

  useEffect(() => {
    if (!vttContent) return;

    const blob = new Blob([vttContent], { type: "text/vtt" });
    const blobUrl = URL.createObjectURL(blob);

    setBlobUrl(blobUrl);

    return () => URL.revokeObjectURL(blobUrl);
  }, [vttContent]);

  return {
    vttContent,
    blobUrl,
    isLoading,
  };
};
